import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

const AdminDashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const ADMIN_EMAILS = ["newton108000@gmail.com", "lumiotec.orders@gmail.com", "okumuwan@gmail.com", "cynthiamusonye1@gmail.com"];

  useEffect(() => {
    if (!currentUser || !ADMIN_EMAILS.includes(currentUser.email)) {
      alert("⛔ Access Denied: Admins Only.");
      navigate("/");
    }
  }, [currentUser, navigate]);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8 border-b pb-4">
        <h1 className="text-3xl font-bold">Admin Dashboard 📊</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link to="/admin/orders" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
          <h2 className="text-xl font-bold mb-2">View Customer Orders</h2>
          <p className="text-gray-600">See a list of all successfully paid and created orders.</p>
        </Link>
        {/* You can add more links here for other admin functionalities like managing products, etc. */}
      </div>
    </div>
  );
};

export default AdminDashboard;